var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10867_31798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 13.5572V4.44338C18.0005 3.18757 16.9761 2.16309 15.7203 2.16309H8.35428C7.09846 2.16309 6.07398 3.18757 6.07398 4.44338V5.91951C6.07398 6.16921 6.27594 6.37116 6.52564 6.37116C6.77533 6.37116 6.97729 6.16921 6.97729 5.91951V4.44338C6.97729 3.68328 7.59785 3.06272 8.35795 3.06272H15.7203C16.4803 3.06272 17.1009 3.68328 17.1009 4.44338V13.5572C17.1009 14.3173 16.4803 14.9379 15.7203 14.9379H8.35428C7.59418 14.9379 6.97362 14.3173 6.97362 13.5572V12.0811C6.97362 11.8314 6.77166 11.6294 6.52197 11.6294C6.27227 11.6294 6.07031 11.8314 6.07031 12.0811V13.5572C6.07031 14.813 7.09479 15.8375 8.35061 15.8375H15.7203C16.9761 15.8375 18.0005 14.8167 18.0005 13.5572Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.132191 9.31967L3.21297 12.4005C3.3011 12.4886 3.41493 12.5326 3.53244 12.5326C3.64994 12.5326 3.76377 12.4886 3.8519 12.4005C4.02815 12.2242 4.02815 11.9415 3.8519 11.7652L1.53856 9.45186H9.97675C10.2264 9.45186 10.4284 9.2499 10.4284 9.00021C10.4284 8.75051 10.2264 8.54856 9.97675 8.54856H1.53488L3.84823 6.23522C4.02448 6.05896 4.02448 5.77622 3.84823 5.59996C3.67197 5.42371 3.38923 5.42371 3.21297 5.59996L0.132191 8.68075C-0.0440637 8.857 -0.0440637 9.14342 0.132191 9.31967Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10867_31798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.95859dd26d5019e2868d7d1f2193e2a8.svg";
export { ForwardRef as ReactComponent };